import gButton from "@/components/g-button/g-button";
import gForm from "@/components/g-form/g-form.vue";
import ActionForm from '@/mixins/ActionForm'
import ClienteController from "@/shared/controllers/cliente/clienteController";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";

const name = 'InfoClienteRA'
export default {
  name,
  mixins: [ActionForm],

  components: {
    'g-button' : gButton,
    'g-form' : gForm
  },

  props: { },

  mounted() {
    this.popularDadoscliente()
    this.incentivos()
    this.ImagemEmpresa()
  },

  updated () { },

  data () {
    return {
        popupCancelaOrc: false,
        pt1: true,
        imagemEmpresa: '',
        TemSuframa: false,
        CnpjText: null,
        CodigoText: null,
        RazaoSocialText: null,
        EstadoText: null,
        CidadeText: null,
        SegmentoText: null,
        ContatoText: null,
        OrcamentoId: null,
        TelefoneText: null,
        RamalText: null,
        SuframaText: null,
        ICMS: false,
        IPI: false,
        PisCofins: false,
        clienteSituacao: null,
        popup: false,
        dataResponse: [],
        AlterarDadosButtonText: 'ALTERAR DADOS',
        ClienteId: null
    }
  },

  methods: {
    cancelaOrcamento() {
      this.$isLoading(true)
      OrcamentoController.DeleteOrcamento(this.$route.params.id).requisicao
      .then(() =>
        this.popupCancelaOrc = false,
        this.$toast.add({severity:'success', detail:'Orçamento Excluido com Sucesso!', life: 5000}),
        setTimeout(() => {
          this.$isLoading(false),
          this.$router.push('/produto-repeticao-alteracao-inicio');
        },2000))
    },
    fechaPopupCancelar() {
      this.popupCancelaOrc = false;
    },
    abrePopupCancelarOrcamento(){
      this.popupCancelaOrc = true;
    },
    ImagemEmpresa(){
      OrcamentoController.GetNomeEmpresaByOrcamentoId(this.$route.params.id).requisicao
      .then((response) => {
        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `http://${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
    },
      step2 () {
        this.$router.push(`/produto-repeticao-alteracao/${this.$route.params.id}/lote-frete-ra`)
      },

      paginainicial () {
          this.$router.push('/produto-repeticao-alteracao-inicio/')
      },

      redireciona(){
        this.EditarCliente(this.informacaoCliente)
      },

      aparecerpopup (infoCliente) {
        this.popup=true
        this.informacaoCliente = infoCliente
      },

      fechaPopup(){
        this.popup = false
      },

      EditarCliente() {
        this.$router.push('/ficha-cadastro')
      },

      modificar(){
        ClienteController.EditarClienteById(this.ClienteId).requisicao
      .then((response ) => {
        this.$store.state.cliente = response.data.data
        this.$store.commit('salvando');

        this.situacaoVindaDoBanco= response.data.data.clienteSituacao

        if (this.situacaoVindaDoBanco === 0){
          this.$router.push(`/ficha-cadastro`)
      } else
        {
        this.$router.push(`/cliente-em-desenvolvimento`)
      }
      })
      .catch(() => {

      })
      },
      incentivos() {
          this.incentivos
          if (this.ICMS === true) {
              this.ICMS = ("ICMS   ")
          } else {
              this.ICMS = ("")
          }

          if (this.IPI === true) {
              this.IPI = ("IPI   ")
          } else {
              this.IPI = ("")
          }

          if (this.PisCofins === true) {
              this.PisCofins = ("PisCofins")
          } else {
              this.PisCofins = ("")
          }
      },

      popularDadoscliente() {
          this.$isLoading(true)
          this.axios({
              method: 'get',
              url: process.env.VUE_APP_WEB_API + `Cliente/GetClienteByOrcamento/${this.$route.params.id}`,
          })
              .then((response) => {
                  this.GetResultForm(response)
                  this.ClienteId = response.data.data.id
                  this.ICMS = this.objForm.icms
                  this.IPI = this.objForm.ipi
                  this.PisCofins = this.objForm.pisCofins
                  this.incentivos()
                  this.clienteSituacao = response.data.data.clienteSituacao
                  if(response.data.data.numeroTelefone === "0"){
                    this.objForm.numeroTelefone = '--';
                  }

                  if(response.data.data.nomeContato === null || response.data.data.nomeContato === "0"){
                    this.objForm.nomeContato = '--';
                  }

                  if(response.data.data.numeroRamal === null || response.data.data.numeroRamal === "0"){
                    this.objForm.numeroRamal = '--';
                  }

                  if(response.data.data.numeroSuframa === null || response.data.data.numeroSuframa === "0"){
                    this.objForm.numeroSuframa = '--';
                  }
              })
              .finally(()=> {
                this.$isLoading(false)
              })
      }

  },

  computed: {
    AjustarGridSuframa() { //caso n�o tnha suframa, ramal pega todo o espa�o
    return this.TemSuframa ? '1 / 1 / 1 / 2' : ' 1 / 1 / 1 / 3 '
    }
  },

};